<icc-list [searchable]="true" [items]="accessories"
          [itemTemplate]="'itemImgTitleDescription'"
          [tabs]="tabs"
          (select)="selectAccessory($event)"
          itemImgHeight="medium"
          ></icc-list>
